import {
    Card,
    CardActions,
    CardContent,
    CardHeader,
    Divider,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TablePagination,
    TableRow,
    Theme
} from '@material-ui/core';
import {makeStyles} from '@material-ui/styles';
import clsx from 'clsx';
import React from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import useRouter from 'use-react-router';
import {TableEditBar} from '../../../components/TableEditBar';
import {PaginatiorInfo} from '../../../graphql/common.datatypes';
import {Group} from '../../../graphql/groups.datatypes';
import {formatDate, formatMoney} from '../../../utils/formatters';
import moment from 'moment';

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        position: 'relative',
    },
    content: {
        padding: 0
    },
    inner: {
      [theme.breakpoints.up('md')]: {
        minWidth: 700,
      },
    },
    nameCell: {
        display: 'flex',
        alignItems: 'center'
    },
    avatar: {
        height: 42,
        width: 42,
        marginRight: theme.spacing(1)
    },
    actions: {
        padding: theme.spacing(1),
        justifyContent: 'flex-end'
    },
}));

const Results = (props: {
  className?: string,
  groups: Group[],
  paginatorInfo?: PaginatiorInfo,
  setPage?: (page: number) => void,
  rowsPerPage?: number,
  setRowsPerPage?: (rowsPerPage: number) => void,
  selectedGroup?: Group,
  setSelectedGroup?: (group: Group) => void,
  onRowClick?: (group: Group) => void,
  isAdmin?: boolean
}) => {
    const {className, rowsPerPage, setPage, setRowsPerPage, paginatorInfo, selectedGroup, setSelectedGroup, groups, onRowClick, isAdmin, ...rest} = props;
    const classes = useStyles();
  const {history} = useRouter();

    const handleChangePage = (event: React.MouseEvent<HTMLButtonElement> | null, page: number) => {
      if (setPage) setPage(page + 1);
    };

    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
      if (setRowsPerPage) setRowsPerPage(Number(event.target.value));
    };

    return (
      <div
        {...rest}
        className={clsx(classes.root, className)}
      >
          <Card>
              <CardHeader
                title={'Groups'}
              />
              <Divider/>
              <CardContent className={classes.content}>
                  <PerfectScrollbar>
                      <div className={classes.inner}>
                          <Table>
                              <TableHead>
                                  <TableRow>
                                      <TableCell>Name</TableCell>
                                      <TableCell>Tour</TableCell>
                                      <TableCell>Hotel</TableCell>
                                      <TableCell style={{width: 100}}>Members</TableCell>
                                      <TableCell style={{width: 100}}>Start Date</TableCell>
                                      <TableCell style={{width: 100}}>End Date</TableCell>
                                      {isAdmin && (<TableCell style={{width: 100}}>Total</TableCell>)}
                                      {isAdmin && (<TableCell style={{width: 100}}>Outstanding</TableCell>)}
                                      {isAdmin && (<TableCell style={{width: 100}}>Past due</TableCell>)}
                                  </TableRow>
                              </TableHead>
                              <TableBody>
                                  {groups.map(group => {
                                      const showPrices = isAdmin || (moment(group.end_date).add(15, 'days').diff(moment(), 'days') > 0);
                                      return (
                                          <TableRow
                                              hover
                                              key={group.id}
                                              selected={selectedGroup === group}
                                              onClick={() => onRowClick ? onRowClick(group) :
                                                  isAdmin ?
                                                      history.push('/groups/' + group.id) :
                                                      history.push('/mygroups/' + group.booking_form_url)
                                              }
                                          >
                                              <TableCell>{group.name}</TableCell>
                                              <TableCell>{isAdmin ? group.tour!.internal_name : group.tour!.display_name}</TableCell>
                                              <TableCell>{isAdmin ? group.hotel!.internal_name : group.hotel!.display_name}</TableCell>
                                              <TableCell>{group.active_members && group.active_members.length}</TableCell>
                                              <TableCell>{formatDate(group.start_date)}</TableCell>
                                              <TableCell>{formatDate(group.end_date)}</TableCell>
                                              {isAdmin && (
                                                  <TableCell>{showPrices ? (formatMoney(group.cost!,true)) : 'n/a'}</TableCell>)}
                                              {isAdmin && (
                                                  <TableCell>{showPrices ? (formatMoney(group.outstandingBalance!,true)) : 'n/a'}</TableCell>)}
                                              {isAdmin && (
                                                  <TableCell>{showPrices ? (formatMoney(group.overduePayments!,true)) : 'n/a'}</TableCell>)}

                                          </TableRow>
                                      )
                                  })}
                              </TableBody>
                          </Table>
                      </div>
                  </PerfectScrollbar>
              </CardContent>
            {paginatorInfo && rowsPerPage && (
              <CardActions className={classes.actions}>
                <TablePagination
                  component="div"
                  count={paginatorInfo.total}
                  onChangePage={handleChangePage}
                  onChangeRowsPerPage={handleChangeRowsPerPage}
                  page={paginatorInfo.currentPage - 1}
                  rowsPerPage={rowsPerPage}
                  rowsPerPageOptions={[25, 50, 100]}
                />
              </CardActions>
            )}
          </Card>
          <TableEditBar selected={[]}/>
      </div>
    );
};

export default Results;
